var ko = require('knockout');
var _ = require('underscore');

// A custom binding that handles pegging an element within its parent element.
// The element must be absolutely positioned within its parent, and its parent
// must be positioned as well.
//
// This method will switch the positioning to static when the pegged element
// needs to move with the window and back to absolute when the pegged element
// needs to move with the page.
//
// If you want the pegged positioning to update when certain view model
// properties change (for example, if it changes the height of the pegged
// element), then make the value an array of the observables that you want to
// cause to update the pegged position of the element when they change.
//
// Example:
//
//   pegWithinParent: []
//   pegWithinParent: [oneChangingObservable, anotherChangingObservable]
//
var listenerAttached = false;

module.exports = {
  init: function(element, valueAccessor) {
    if (!supportsPegWithinParent()) {
      return;
    }
    // Listen for changes on each of the observables by unwrapping them
    dependOnObservables(valueAccessor());

    // Add the element to the set of pegged elements to update with the page
    peggedElements.push(makeElementRecord(element));

    if (!listenerAttached) {
      listenerAttached = true;
      $(function() {
        lastScrollTop = $(window).scrollTop();
        $(window).scroll(updatePeggedElements_);
        $(window).resize(updatePeggedElements_);
      });
    }
  },

  update: function(element, valueAccessor) {
    if (!supportsPegWithinParent()) {
      return;
    }

    // Continue to depend on observables each time we update
    dependOnObservables(valueAccessor());

    // Update this pegged element after a timeout to allow other change that
    // might affect the height to trigger first.
    setTimeout(function() {
      // Force update by clearing last scroll top.
      lastScrollTop = null;
      updateElements_([findElementRecord(element)]);
    });
  }
};

var peggedElements = [];
var lastScrollTop = null;

var updatePeggedElements_ = function() {
  updateElements_(peggedElements);
};

var updateElements_ = function(elementsToUpdate) {
  var $window = $(window);
  var viewHeight = $window.height();
  var scrollTop = $window.scrollTop();
  var scrollBottom = scrollTop + viewHeight;
  _.each(elementsToUpdate, function(p) {
    if (scrollTop > lastScrollTop) {
      // Scrolling down
      var elementTop = p.element.offset().top;
      var elementHeight = p.element.outerHeight();
      var elementBottom = elementTop + elementHeight;
      var parentTop = p.parent.offset().top;
      var parentHeight = p.parent.height();
      var parentBottom = parentTop + parentHeight;

      if (elementHeight >= viewHeight) {
        // Dragged by the bottom of the viewport, limited by the bottom of the parent
        if ((p.position == 'absolute' && elementBottom < scrollBottom && scrollBottom < parentBottom) || (p.position == 'fixed' && parseInt(p.element.css('top')) < viewHeight - elementHeight)) {
          p.position = 'fixed';
          p.element.css({position: 'fixed', top: (viewHeight - elementHeight) + 'px'});
        } else if (p.position == 'fixed' && elementBottom > scrollBottom) {
          p.position = 'absolute';
          p.element.css({position: 'absolute', top: Math.min(elementTop - parentTop, parentHeight - elementHeight) + 'px'});
        } else if (scrollBottom > parentBottom && elementBottom != parentBottom) {
          p.position = 'absolute';
          p.element.css({position: 'absolute', top: (parentHeight - elementHeight) + 'px'});
        }
      } else {
        // Pushed by the top of the viewport, limited by the bottom of the parent
        var availableHeight = parentBottom - scrollTop;

        if (p.position == 'absolute' && elementTop < scrollTop && elementBottom < parentBottom && availableHeight >= elementHeight) {
          p.position = 'fixed';
          p.element.css({position: 'fixed', top: '0px'});
        } else if ((p.position == 'fixed' && elementBottom > parentBottom) || (p.position == 'absolute' && elementTop < scrollTop && elementBottom < parentBottom && availableHeight < elementHeight)) {
          p.position = 'absolute';
          p.element.css({position: 'absolute', top: (parentHeight - elementHeight) + 'px'});
        }
      }
    } else if (scrollTop < lastScrollTop) {
      // Scrolling up - Pulled by the top of the viewport, limited by the top of the parent
      var elementTop = p.element.offset().top;
      var parentTop = p.parent.offset().top;

      if (p.position == 'absolute' && elementTop > scrollTop && scrollTop > parentTop) {
        p.position = 'fixed';
        p.element.css({position: 'fixed', top: '0px'});
      } else if (p.position == 'fixed' && elementTop < scrollTop) {
        p.position = 'absolute';
        p.element.css({position: 'absolute', top: Math.max(elementTop - parentTop, 0) + 'px'});
      } else if (scrollTop < parentTop && elementTop != parentTop) {
        p.position = 'absolute';
        p.element.css({position: 'absolute', top: '0px'});
      }
    }
  });

  lastScrollTop = scrollTop;
};

var makeElementRecord = function(element) {
  var $element = $(element);
  return {
    element: $element,
    parent: $element.parent(),
    position: 'absolute'
  };
};

var findElementRecord = function(element) {
  return _.detect(peggedElements, function(elementRecord) {
    return elementRecord.element.get(0) == element;
  });
};

var dependOnObservables = function(observables) {
  if (_.isArray(observables)) {
    _.each(observables, function(observable) {
      ko.utils.unwrapObservable(observable);
    });
  }
};

// IE6 and earlier doesn't support pegging because it doesn't support fixed
// positioning. Touch platforms don't support pegging because they either
// don't fully support fixed position or don't fire scroll events often
// enough.
var supportsPegWithinParentResult;
var supportsPegWithinParent = function() {
  if (_.isUndefined(supportsPegWithinParentResult)) {
    supportsPegWithinParentResult =
      ($.browser.msie && $.browser.version <= 6) ||
      !navigator.userAgent.match(/iPhone|iPod|iPad|Android|Opera Mobi/);
  }

  return supportsPegWithinParentResult;
};
